/**
 * WithingsSyncPage - Route-Komponente für Sync Tab
 * Wrapper um SyncTab mit Router-Integration
 */

import React from "react";

import { useWithingsData } from "../../hooks/useWithingsData";
import { SyncTab } from "./SyncTab";

export const WithingsSyncPage: React.FC = () => {
  const {
    dateRangeEnd,
    dateRangeStart,
    handleDateRangeSync,
    isSyncing,
    onSyncComplete,
    setDateRangeEnd,
    setDateRangeStart,
    setShowDateRangeModal,
    showDateRangeModal,
    syncResult,
    syncStatus,
  } = useWithingsData();

  return (
    <SyncTab
      dateRangeEnd={dateRangeEnd ?? ""}
      dateRangeStart={dateRangeStart}
      isSyncing={isSyncing}
      onDateRangeSync={(start, end) => {
        void handleDateRangeSync(start, end);
      }}
      onForceSync={() => {
        void onSyncComplete();
      }}
      onSmartSync={() => {
        void onSyncComplete();
      }}
      setDateRangeEnd={setDateRangeEnd}
      setDateRangeStart={setDateRangeStart}
      setShowDateRangeModal={setShowDateRangeModal}
      showDateRangeModal={showDateRangeModal}
      syncResult={syncResult ?? null}
      syncStatus={syncStatus}
    />
  );
};
